import React from "react";

import RenderOrientations, {
    RenderOrientationFlow,
} from "../../types/enums/RenderOrientation";

interface ContainerHeaderProps {
    className?: string;
    direction?: RenderOrientationFlow;

    children?: React.ReactNode | React.ReactNode[];
}

interface ContainerHeaderState {}

class ContainerHeader extends React.Component<ContainerHeaderProps, ContainerHeaderState> {
    render(): React.ReactNode {
        let classNames = "header";

        if (this.props.className) classNames += ` ${this.props.className}`;

        switch (this.props.direction) {
            case RenderOrientations.RightLeft:
                classNames += " flex-row-reverse";
                break;
            default:
                classNames += " flex-row";
                break;
        }

        return <div className={classNames}>{this.props.children}</div>;
    }
}

export default ContainerHeader;
